import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {User} from "../../../../../user/user";
import {Router} from "@angular/router";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import {DashboardUtils} from "../../../../../shared/utils/dashboard-utils";
import successPoints from "./demo-success-points.json";
import {filter, first, takeUntil} from "rxjs/operators";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {UserService} from "../../../../../user/user.service";
import {UserSubscription} from "../../../../../user/user-subscription";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../../store";
import {
  GlobalEventDispatcherService
} from "../../../../services/global-event-dispatcher/global-event-dispatcher.service";
import {GlobalEvent} from "../../../../services/global-event-dispatcher/global-event";
import {CookieService} from "ngx-cookie";
import {BuilderSectionsInteractionService} from "../../../../../builder-v2/builder-sections-interaction.service";
import {Subject} from "rxjs";

@Component({
    selector: 'db-demo-progress-done',
    templateUrl: './demo-progress-done.component.html',
    styleUrls: ['./demo-progress-done.component.scss'],
    standalone: false
})
export class DemoProgressDoneComponent implements OnInit {

  @Input() user: User;
  @Input() campaignInfo: any;
  @Input() userLocalStorage: any;
  @Input() websiteData: any;
  @Input() websiteId: number;
  @Input() websiteUrl: string;
  @Input() pageId = '';
  @Input() isEcommerce: boolean;
  @Input() forMobileEdit: boolean;
  @Input() subscription: UserSubscription;

  @Output() onEditCLick: EventEmitter<any> = new EventEmitter();
  companyName: string = 'Dashboard';
  public steps: any;
  public currentStep: number = 0;
  public points = successPoints;
  public isMobile = false;
  public loadingMagicLink: boolean;
  public wpAdminUrl: string | null = null;
  private _destroyStream$: Subject<void> = new Subject<void>();

  constructor(
    private readonly _router: Router,
    private _store: Store<fromStore.DbStoreState>,
    private readonly _activeModal: DbActiveModal,
    private readonly _userService: UserService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _globalEventDispatcher: GlobalEventDispatcherService,
    private _builderSectionsInteractionService: BuilderSectionsInteractionService,
    private _cookieService: CookieService,
  ) {
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 768;
    this.wpAdminUrl = DashboardUtils.generateWpAdminRedirectorUrl(
      this.websiteId,
      this.websiteUrl + '/wp-admin/?edit.php?post_type=page&from=tenweb_dashboard&open=homepage',
      this.user.email
    );
    this._getCompanyInfo();
  }

    private _getCompanyInfo(): void {
        this._builderSectionsInteractionService.companyInfo
            .pipe(
                filter(companyInfo => !!companyInfo),
                takeUntil(this._destroyStream$),
                first()
            )
            .subscribe(companyInfo => {
                this.companyName = companyInfo?.branding?.company_name || companyInfo?.agency?.name || 'YourBrand';
            });
    }

  proceed() {
    const pagePath = this.isEcommerce ? '/main' : '/ai-builder';
    this._router.navigate([`/websites/${this.websiteId}` + pagePath], {
      queryParams: {isNavigating: true}  // Pass custom state
    }).then(() => {
      this._store.dispatch(new fromStore.LoadUser());
      this._store.dispatch(new fromStore.LoadUserSubscription());
      this._store.dispatch(new fromStore.LoadInfo(this.websiteId));
    });
    this._globalEventDispatcher.dispatchEvent(GlobalEvent.showDemoPreviewIframe, {showIframe: false});
    localStorage.removeItem('dbDemoCampaignInfo');
    const hasResurrectionCoupon =  this._cookieService.get('dbCouponFromEmail');
    if (hasResurrectionCoupon) this._cookieService.remove('dbCouponFromEmail');
  }

  public sendMagicLink() {
    const magicLinkPath = '/websites/' + this.websiteId + '/ai-builder';
    this.loadingMagicLink = true;
    this._userService.sendMagicLinkEmailPublic(this.user?.email, magicLinkPath)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe((response) => {
        this.loadingMagicLink = false;
        if (response.success) {
          this._router.navigate([`/websites/${this.websiteId}` + magicLinkPath]);
          this.onEditCLick.emit();
          this._globalEventDispatcher.dispatchEvent(GlobalEvent.showDemoPreviewIframe, {showIframe: false});
          NotifierComponent.notify(new Notification('Magic link sent to your email', NotificationType.SUCCESS));
          localStorage.removeItem('dbDemoCampaignInfo');
          const hasResurrectionCoupon =  this._cookieService.get('dbCouponFromEmail');
          if (hasResurrectionCoupon) this._cookieService.remove('dbCouponFromEmail');
        }
      });
  }
}
